import { getPath } from '@/router/common'

const baseUrl = {
  title: '现金日记账',
  path: 'CashDayAccount'
}

export default [
  {
    path: getPath('CashDayAccount_Index', baseUrl),
    name: 'CashDayAccount_CashDayAccount_Index',
    component: () => import(/* webpackChunkName: "CashDayAccount_CashDayAccount_Index" */ '@/views/cashDayAccount/cashDayAccount_Index/index.vue'),
    meta: {
      title: '现金日记账'
    }
  }
]
